// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "./Util.bs.js";
import * as Decco from "decco/lib/es6/src/Decco.bs.js";
import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Tailwind from "./Tailwind.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/lib/es6/src/Core__Option.bs.js";
import * as Core__Result from "@rescript/core/lib/es6/src/Core__Result.bs.js";
import * as ReadingJson from "/static/Reading.json";

function book_encode(v) {
  return Js_dict.fromArray([
              [
                "title",
                Decco.stringToJson(v.title)
              ],
              [
                "author",
                Decco.stringToJson(v.author)
              ],
              [
                "link",
                Decco.stringToJson(v.link)
              ],
              [
                "translator",
                Decco.optionToJson(Decco.stringToJson, v.translator)
              ]
            ]);
}

function book_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var author = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "author"), null));
    if (author.TAG === /* Ok */0) {
      var link = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "link"), null));
      if (link.TAG === /* Ok */0) {
        var translator = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "translator"), null));
        if (translator.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    title: title._0,
                    author: author._0,
                    link: link._0,
                    translator: translator._0
                  }
                };
        }
        var e = translator._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".translator" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = link._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".link" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = author._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".author" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function reading_encode(v) {
  return Decco.arrayToJson(book_encode, v);
}

function reading_decode(v) {
  return Decco.arrayFromJson(book_decode, v);
}

function Reading(props) {
  var inputRef = props.inputRef;
  return Util.getOrErrorPage(Core__Result.map(Decco.arrayFromJson(book_decode, ReadingJson), (function (books) {
                    return React.createElement("ul", {
                                ref: Caml_option.some(inputRef),
                                className: Tailwind.divideClassName
                              }, Belt_Array.mapWithIndex(books, (function (i, param) {
                                      return React.createElement("li", {
                                                  key: i.toString()
                                                }, React.createElement("a", {
                                                      className: Tailwind.clickableClassName,
                                                      href: param.link,
                                                      target: "_blank"
                                                    }, React.createElement("div", {
                                                          className: "flex flex-col  " + Tailwind.padding + ""
                                                        }, React.createElement("div", {
                                                              className: "flex flex-row space-x-4"
                                                            }, React.createElement("h2", {
                                                                  className: Tailwind.h2ClassName
                                                                }, param.title), React.createElement("p", undefined, param.author)), Core__Option.mapOr(param.translator, React.createElement(React.Fragment, undefined), (function (translator) {
                                                                return React.createElement("p", {
                                                                            className: Tailwind.liPrimaryClassName
                                                                          }, "Translated by " + translator + "");
                                                              })))));
                                    })));
                  })));
}

var $$Array;

var make = Reading;

export {
  $$Array ,
  book_encode ,
  book_decode ,
  reading_encode ,
  reading_decode ,
  make ,
}
/* Util Not a pure module */
